import styled from "@emotion/styled";
import {font} from "../../styles/theme.js";
import {textStyles} from "../text/index.js";

export const MarkdownBulletsList = styled.ul(({theme, styles}) => ({
  listStyleType: "none",
  position: "relative",
  paddingInlineStart: 0,
  marginLeft: 34,
  marginBlock: "24px 0",
  borderLeft: `1px solid ${theme?.colors?.brandLightBlue}`,
  paddingLeft: 16,
  paddingTop: 1,
  paddingBottom: 1,
  ...textStyles(theme).textLarge,
  li: {
    position: "relative",
    margin: "16px 0",
    ...styles,
    "::before": {
      content: '"•"',
      position: "absolute",
      top: 0,
      left: -43,
      color: theme?.colors?.brandLightBlue,
      fontSize: "2rem",
      lineHeight: "1.75rem",
    },
  },
}));

export const MarkdownOrderedList = styled.ol(({theme, styles}) => ({
  listStyleType: "none",
  position: "relative",
  paddingInlineStart: 0,
  marginLeft: 34,
  borderLeft: `1px solid ${theme?.colors?.brandLightBlue}`,
  paddingLeft: 16,
  paddingTop: 1,
  paddingBottom: 1,
  letterSpacing: "0.02px",
  fontStyle: "normal",
  ...textStyles(theme).textLarge,
  li: {
    position: "relative",
    margin: "16px 0",
    counterIncrement: "i",
    fontStyle: "normal",
    ...styles,
    "::before": {
      content: "counter(i)",
      position: "absolute",
      top: 0,
      left: -40,
      color: theme?.colors?.brandLightBlue,
      fontSize: "1.5rem",
      fontStyle: "normal",
      fontFamily: font.arvo,
      fontWeight: 700,
      lineHeight: "1.75rem",
    },
    "&:nth-of-type(n+10)::before": {
      left: -50,
    },
    "&:nth-of-type(10n+1)::before": {
      left: -49,
      letterSpacing: "2px",
    },
    "&:nth-of-type(1)::before": {
      left: -37,
    },
  },
}));

export const ScrollableTableWrapper = styled.div({
  overflowX: "scroll",
  minWidth: "100%",
});

export const MarkdownTable = styled.table(({theme}) => ({
  border: "1px solid",
  borderColor: theme?.colors?.borderBlue,
  borderCollapse: "collapse",
  width: "auto",
  minWidth: "100%",
}));

export const MarkdownTh = styled.th(({theme}) => ({
  border: "1px solid",
  borderColor: theme?.colors?.borderBlue,
  borderCollapse: "collapse",
}));

export const MarkdownTd = styled.td(({theme}) => ({
  ...textStyles(theme).bodyRegular,
  border: "1px solid",
  borderColor: theme?.colors?.borderBlue,
  borderCollapse: "collapse",
  padding: "16px 8px",
  minWidth: theme?.breakpoints?.isMobile ? 110 : "auto",
}));

export const MarkdownH5 = styled.h5(({theme, styles}) => ({
  ...textStyles(theme).titleExtraSmall,
  ...styles,
}));

export const MarkdownP = styled.p(({theme}) => ({
  ...textStyles(theme).textLarge,
  "img, a": {
    marginBlock: 16,
  },
}));

export const MarkdownA = styled.a(({theme, style}) => ({
  ...textStyles(theme).textLarge,
  textDecoration: "none",
  ...style,
}));
